var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitShutdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_9400_530_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "url(#paint0_linear_9400_530)",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_1_9400_530_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 18.5,
    fill: "url(#paint1_linear_9400_530)",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 29.4L26.8 29M27.7 31.6L26.8 32M28.5 14.5V18.5M29.4 27.7L29 26.8M29.4 33.3L29 34.2M32 26.8L31.6 27.7M32 34.2L31.6 33.3M33.5 23V18.5C33.5 17.9696 33.2893 17.4609 32.9142 17.0858C32.5391 16.7107 32.0304 16.5 31.5 16.5H17.5C16.9696 16.5 16.4609 16.7107 16.0858 17.0858C15.7107 17.4609 15.5 17.9696 15.5 18.5V32.5C15.5 33.0304 15.7107 33.5391 16.0858 33.9142C16.4609 34.2893 16.9696 34.5 17.5 34.5H23.5M34.2 29L33.3 29.4M34.2 32L33.3 31.6M15.5 22.5H33.5M20.5 14.5V18.5M33.5 30.5C33.5 32.1569 32.1569 33.5 30.5 33.5C28.8431 33.5 27.5 32.1569 27.5 30.5C27.5 28.8431 28.8431 27.5 30.5 27.5C32.1569 27.5 33.5 28.8431 33.5 30.5Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9400_530_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9400_530_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 18.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9400_530",
    x1: 25.213,
    y1: 8.91922,
    x2: 23.8224,
    y2: 44.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9400_530",
    x1: 25.0384,
    y1: 12.7349,
    x2: 23.9883,
    y2: 39.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitShutdown);
export default __webpack_public_path__ + "res/media/benefit-shutdown.8a6dd10ba8b0c5bfefc08d7e23faaaad.svg";
export { ForwardRef as ReactComponent };